import { useEffect, useRef, useState } from 'react';
import { FloatButton } from '../../components/FloatButton/FloatButton';
import './Fullscreen.css';

export const Fullscreen = (props) => {
  const { cdn, room } = props;

  const [isLoading, setIsLoading] = useState(true);
  const [zoom, setZoom] = useState(room.scale.fullscreen);
  const [pan, setPan] = useState(room.coords.fullscreen);

  const lastTouchPosition = useRef(null); // Dernière position pour le pan
  const initialPinchDistance = useRef(null); // Distance initiale pour pinch-to-zoom
  const initialZoom = useRef(zoom); // Zoom initial pour pinch-to-zoom

  const handleTouchStart = (event) => {
    if (event.touches.length === 1) {
      // Pan avec un seul doigt
      lastTouchPosition.current = { x: event.touches[0].clientX, y: event.touches[0].clientY };
    } else if (event.touches.length === 2) {
      // Zoom avec deux doigts
      const dx = event.touches[1].clientX - event.touches[0].clientX;
      const dy = event.touches[1].clientY - event.touches[0].clientY;
      initialPinchDistance.current = Math.sqrt(dx * dx + dy * dy); // Distance initiale entre les doigts
      initialZoom.current = zoom; // Stocke le zoom actuel
    }
  };

  const handleTouchMove = (event) => {
    if (event.touches.length === 1 && !initialPinchDistance.current) {
      // Pan uniquement si aucun zoom n'est en cours
      const dx = event.touches[0].clientX - lastTouchPosition.current.x;
      const dy = event.touches[0].clientY - lastTouchPosition.current.y;

      setPan((prevPan) => ({
        x: prevPan.x + dx,
        y: prevPan.y + dy,
      }));

      lastTouchPosition.current = { x: event.touches[0].clientX, y: event.touches[0].clientY };
    } else if (event.touches.length === 2) {
      // Zoom avec deux doigts
      const dx = event.touches[1].clientX - event.touches[0].clientX;
      const dy = event.touches[1].clientY - event.touches[0].clientY;
      const newDistance = Math.sqrt(dx * dx + dy * dy);

      if (initialPinchDistance.current) {
        const scaleFactor = newDistance / initialPinchDistance.current;
        setZoom(Math.max(initialZoom.current * scaleFactor, 0.5)); // Zoom minimum à 0.5
      }
    }
  };

  const handleTouchEnd = (event) => {
    if (event.touches.length === 0) {
      // Réinitialiser les données de zoom lorsqu'il n'y a plus que 1 ou 0 doigt
      initialPinchDistance.current = null;
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className="page fullscreen-page"
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      {isLoading ? (
        <div className="fullscreen-page__loader">
          <img
            className="fullscreen-page__loader__img"
            alt="Chargement"
            src={`${cdn}pictos/load.svg`}
          />
        </div>
      ) : null}
      <FloatButton cdn={cdn} type="collapse" />
      <div className="fullscreen-page__bat">
        <img
          className="fullscreen-page__bat__img"
          alt={`Bâtiment ${room.level.split('')[1]}`}
          src={`${cdn}bats/bat_${room.level.split('')[1].toLowerCase()}.svg`}
        />
      </div>
      <object
        className="fullscreen-page__img"
        type="image/svg+xml"
        data={`${cdn}plans/plan_${room.level}.svg`}
        style={{
          transform: `scale(${zoom}) translate(${pan.x / zoom}px, ${pan.y / zoom}px)`,
          transformOrigin: 'center center',
        }}
      >
        Plan
      </object>
    </div>
  );
};
